import { Row, Col, Radio, Checkbox, Steps, Button, theme, Input, Select, Form, Alert } from 'antd';
import { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { FiArrowLeft, FiArrowRight, FiCheck } from "react-icons/fi";
import { FaCircleCheck } from "react-icons/fa6";
import { Link } from 'react-router-dom';

export const Builder = () => {

        const [ form ] = Form.useForm();
        const { token } = theme.useToken();
        const [ current, setCurrent ] = useState(0);
        const [ answers, setAnswers ] = useState({})

        const industries = [
                {"id": 18, "name": "Other"},
                {"id": 16, "name": "Automotive"},
                {"id": 1, "name": "Agriculture and Forestry"},
                {"id": 2, "name": "Construction and Real Estate"},
                {"id": 3, "name": "Consumer Goods and Retail"},
                {"id": 4, "name": "Education and Training"},
                {"id": 5, "name": "Energy and Utilities"},
                {"id": 6, "name": "Financial Services"},
                {"id": 17, "name": "Health & Fitness"},
                {"id": 7, "name": "Healthcare and Pharmaceuticals"},
                {"id": 8, "name": "Hospitality and Tourism"},
                {"id": 9, "name": "Information Technology and Telecommunications"},
                {"id": 10, "name": "Manufacturing and Engineering"},
                {"id": 11, "name": "Media, Entertainment, and Arts"},
                {"id": 12, "name": "Non-Profit and Government"},
                {"id": 13, "name": "Professional Services"},
                {"id": 14, "name": "Transport and Logistics"},
                {"id": 15, "name": "Environmental and Green Technologies"}
        ]
        
        
        const questions = [
            {
				name:		"Audience",
                title:		"What type of audience are you looking to target?",
                answers:	[
                        		{
									label:	"Consumers",
                                    name: 	"Consumers", 
                                    type:	"button"
                                },
                                {
                                    label: 	"Businesses",
									name: 	"Businesses",
                                    type:	"button"
                                }
                        	]
            },
			{
				name:		"Location",
                title:		"Where does your audience live?",
                answers:	[
                        		{
                                    label: 	"Local area", 
									name: 	"Local Area", 
                                    type:	"button",
                                },
                                {
                                    label: 	"Across a region",
									name: 	"Region",
                                    type:	"button"
                                },
								{
                                    label: 	"Nationally",
									name: 	"Nationally",
                                    type:	"button"
                                }
                        	]
            },
			{
				name:		"Age",
                title:		"What age are your perfect customers?",
                answers:	[
                        		{
                                    name: 	"Age Groups", 
									label:	"Specific ages",
                                    type:	"button",
                                },
                                {
                                    label: 	"Anyone with an interest",
									name: 	"Anyone with an interest",
                                    type:	"button"
                                }
                        	]
            },
			{
				name:		"Offer",
                title:		"What do you offer your audience?",
                answers:	[
                        		{
									label:	"Products",
                                    name: 	"Products", 
                                    type:	"button"
                                },
                                {
                                    label: 	"Serices",
									name: 	"Services",
                                    type:	"button"
                                }
                        	]
            },
			{
				name:		"OfferType",
                title:		"How do you provider what you offer?",
                answers:	[
                        		{
									label:	"In Person",
                                    name: 	"Inperson", 
                                    type:	"button"
                                },
                                {
                                    label: 	"Remotely",
									name: 	"Remotely",
                                    type:	"button"
                                }
                        	]
            },
			{
				name:		"Goals",
                title:		"What is most important to your business?",
                answers:	[
                        		{
									label:	"Enquiries",
                                    name: 	"Enquiries", 
                                    type:	"button"
                                },
                                {
                                    label: 	"Leads",
									name: 	"Leads",
                                    type:	"button"
                                },
								{
                                    label: 	"Sales",
									name: 	"Sales",
                                    type:	"button"
                                }
                        	]
            },
			{
				name:		"Industry",
                title:		"Select your industry",
                answers:	[
                        		{
                                    name: 	"Industry", 
									label:	"Industry",
                                    type:	"select",
									data:	industries
                                },
                        	]
            },
			
			
        ]

		useEffect( () => {

			console.log(answers)

		}, [answers])

		const [ selected, setSelected ] = useState(2)

		const investment = () => {

			return (
					<Row>
							<Col sm={24}>
									<div style={{backgroundColor: 'white', padding: '0px 50px'}}>
									{<Link style={{fontSize: 20, textDecoration: 'none', color: 'black'}} onClick={() => setCurrent(current -1)}><FiArrowLeft/> GO BACK</Link>}
									<h2 style={{marginBottom: 20}}>Investment</h2>
										<p style={{fontSize: 20}}>Please choose your prefered investment level</p>
											<div className="option">
													
													{/* <p>
															Based on your answers, we've calculated the following investment levels.
													</p> */}
													<Row gutter={15}>
															<Col sm={8}>
																	<div onClick={() => setSelected(1) } className={`package ${selected === 1 ? "selected" : ""}`}>
																			{ selected === 1 && <div className="checked"><FaCircleCheck color="#5E4EE0" size={40} /></div> }
																			<Row gutter={15} type="flex">
																					<Col sm={24}>
																							<div className="name">
																									<h5>Starter</h5>
																									<ul>
																											<li><FiCheck color="green"/> Manage Ad campaigns</li>
																											<li><FiCheck color="green"/> Run social accounts</li>
																											<li><FiCheck color="green"/> Website management</li>
																											<li><FiCheck color="green"/> Regular content</li>
																											<li><FiCheck color="green"/> Graphic design</li>
																											<li><FiCheck color="green"/> Boost search rankings</li>
																											<li><FiCheck color="green"/> Monthly optimisation</li>
																									</ul>
																							</div>
																					</Col>
																					<Col sm={24}>
																							<div className="priceArea">
																									<div className="price">
																											Search Ad spend: £585
																									</div>
																									<div className="price">
																											Social Ad spend: £385
																									</div>
																									<div className="price">
																											Management: £500
																									</div>
																									<br/>
																									
																									<div className="price">
																											<div className="total">
																											£885
																											</div>
																											{/* <Button type="package">Save Package</Button>   */}
																									</div>
																							</div>
																					</Col>
																			</Row>
																	</div>
															</Col>
															<Col sm={8}>
																	<div onClick={() => setSelected(2) } className={`package ${selected === 2 ? "selected" : ""}`}>
																			{ selected === 2 && <div className="checked"><FaCircleCheck color="#5E4EE0" size={40} /></div> }
																			<Row gutter={15} type="flex">
																					<Col sm={24}>
																							<div className="name">
																									<h5>Advanced</h5>
																									<ul>
																											<li><FiCheck color="green"/> Manage Ad campaigns</li>
																											<li><FiCheck color="green"/> Run social accounts</li>
																											<li><FiCheck color="green"/> Website management</li>
																											<li><FiCheck color="green"/> Regular content</li>
																											<li><FiCheck color="green"/> Graphic design</li>
																											<li><FiCheck color="green"/> Boost search rankings</li>
																											<li><FiCheck color="green"/> Weekly optimisation</li>
																									</ul>
																							</div>
																					</Col>
																					<Col sm={24}>
																							<div className="priceArea">
																							<div className="price">
																											Search Ad spend: £585
																									</div>
																									<div className="price">
																											Social Ad spend: £385
																									</div>
																									<div className="price">
																											Management: £700
																									</div>
																									<br/>
																									
																									<div className="price">
																											<div className="total">
																											£1,185
																											</div>
																											{/* <Button type="package">Save Package</Button>   */}
																									</div>
																							</div>
																					</Col>
																			</Row>
																	</div>
															</Col>
															<Col sm={8}>
																	<div onClick={() => setSelected(3) } className={`package ${selected === 3 ? "selected" : ""}`}>
																			{ selected === 3 && <div className="checked"><FaCircleCheck color="#5E4EE0" size={40} /></div> }
																			<Row gutter={15} type="flex">
																					<Col sm={24}>
																							<div className="name">
																									<h5>Ultra</h5>
																									<ul>
																											<li><FiCheck color="green"/> Manage Ad campaigns</li>
																											<li><FiCheck color="green"/> Run social accounts</li>
																											<li><FiCheck color="green"/> Website management</li>
																											<li><FiCheck color="green"/> Regular content</li>
																											<li><FiCheck color="green"/> Graphic design</li>
																											<li><FiCheck color="green"/> Boost search rankings</li>
																											<li><FiCheck color="green"/> Weekly optimisation</li>
																									</ul>
																							</div>
																					</Col>
																					<Col sm={24}>
																							<div className="priceArea">
																							<div className="price">
																											Search Ad spend: £585
																									</div>
																									<div className="price">
																											Social Ad spend: £385
																									</div>
																									<div className="price">
																											Management: £800
																									</div>
																									<br/>
																									
																									<div className="price">
																											<div className="total">
																											£1,685
																											</div>
																									{/* <Button type="package">Save Package</Button>   */}
																									</div>
																							</div>
																					</Col>
																			</Row>
																	</div>
															</Col>
													</Row>
													
													
													
											</div>
									</div>
							</Col>
							
					</Row>
			)
	}
		

		const RenderQuestion = ({q}) => {

			const gotoNext = (a, value) => {
			
				setAnswers({
					...answers,
					[q.name]:	value
				})
	
				setCurrent(current + 1)
			}

			return (
				<div className="questions" style={{height: window.innerHeight - 500}}>

					<div style={{flex: 1}}>
					<div>
					{current > 0 && <Link style={{fontSize: 20, textDecoration: 'none', color: 'black'}} onClick={() => setCurrent(current -1)}><FiArrowLeft/> GO BACK</Link>}
					<h3>{q.title}</h3>
					</div>
					<div>
					{ q.answers.map((a) => {

						return (
							<>
							{ a.type === "button" && <Button onClick={() => gotoNext(a, a.name) } type="primary">{a.label}</Button> }
							{ a.type === "select" && <Select onChange={(v) => gotoNext(a, v)} value={answers[q.name]} style={{width: 500, height: 50}}>{a.data.map((d) => <Select.Option value={d.id}>{d.name}</Select.Option>) }</Select> }
							</>
						)

					})}
					</div>
					</div>
				</div>
			)
		}

      
        
        return (
                <>
                <Helmet>
                        <meta charSet="utf-8" />
                        <title>Package Builder</title>
                </Helmet>
                <div className="page">
                        
                        <div className="section">
                                <div className="container">
									
									{ current < questions.length ?
									<RenderQuestion q={questions[current]}/>
									:
									<div className="questions">
										{investment() }
										
									</div> }
                                </div>
                        </div>
                </div>
                </>
        )
}